import { Controller } from "stimulus";

// Keeps the enclosing form's submit button disabled until the input is exactly the phrase. Used by
// the bulk delete-episodes modal. BackgroundAction#confirmation_phrase_matches enforces the same
// comparison on the server; this is only a convenience.
export default class extends Controller {
  static targets = ["input"];
  static values = { phrase: String };

  connect() {
    this.form = this.element.closest("form");
    // form_controller re-enables every submit button on turbo:submit-end; defer so this runs after it.
    this.recheck = () => setTimeout(() => this.update(), 0);
    this.form.addEventListener("turbo:submit-end", this.recheck);
    this.update();
  }

  disconnect() {
    this.form.removeEventListener("turbo:submit-end", this.recheck);
  }

  update() {
    this.submitButton.disabled = this.inputTarget.value !== this.phraseValue;
  }

  get submitButton() {
    return this.form.querySelector('[type="submit"]:not([formaction])');
  }
}
